"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Youtube, MessageCircle, Radio, Linkedin, Music, Phone, Mail } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-white/10 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm font-sans text-white hover:text-secondary transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="bg-dark-section text-white section-padding border-t border-white/5" aria-label="Phoenix Enterprise Footer">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Feb-17-2026-07_41_59-PM.png" alt="Phoenix Enterprise TCP" className="h-7" />
            </Link>
            <p className="mt-6 text-sm font-sans leading-relaxed text-white/70 max-w-xs">
              Premium chauffeur service in Los Angeles and surrounding areas. Experience luxury, punctuality, and professional excellence.
            </p>
          </div>

          <Separator orientation="vertical" className="hidden md:block h-full bg-secondary/20 w-px" />

          {}
          <div className="flex flex-col">
            <h3 className="font-display text-xl font-semibold mb-6 text-white tracking-wide">
              Quick Links
            </h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <Separator orientation="vertical" className="hidden md:block h-full bg-secondary/20 w-px" />

          {}
          <div className="flex flex-col">
            <h3 className="font-display text-xl font-semibold mb-6 text-white tracking-wide">
              Contact Info
            </h3>
            <div className="flex flex-col gap-4 text-sm font-sans text-white/80">
              <div className="flex items-center gap-3">
                <Phone className="size-4 text-secondary" />
                <Link to="tel:3234926292" className="hover:text-secondary transition-colors">323-492-6292</Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 text-secondary" />
                <Link to="mailto:phoenixenerprises@gmail.com" className="hover:text-secondary transition-colors break-all">phoenixenerprises@gmail.com</Link>
              </div>
              <p className="mt-2 text-white/60 italic">Serving Los Angeles & Surrounding Areas</p>
            </div>
          </div>

          <Separator orientation="vertical" className="hidden md:block h-full bg-secondary/20 w-px" />

          {}
          <div className="flex flex-col">
            <h3 className="font-display text-xl font-semibold mb-6 text-white tracking-wide">
              Follow Us
            </h3>
            <div className="flex flex-wrap gap-3">
              <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="p-2.5 rounded-md border border-secondary/40 text-secondary hover:bg-secondary/10 hover-lift transition-all duration-[var(--duration-medium)]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://instagram.com" newTab className="p-2.5 rounded-md border border-secondary/40 text-secondary hover:bg-secondary/10 hover-lift transition-all duration-[var(--duration-medium)]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://youtube.com" newTab className="p-2.5 rounded-md border border-secondary/40 text-secondary hover:bg-secondary/10 hover-lift transition-all duration-[var(--duration-medium)]" aria-label="YouTube">
                <Youtube className="size-5" />
              </Link>
              <Link to="https://linkedin.com" newTab className="p-2.5 rounded-md border border-secondary/40 text-secondary hover:bg-secondary/10 hover-lift transition-all duration-[var(--duration-medium)]" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="w-full mb-8 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-sans text-white/50">
          <p>&copy; {currentYear} Phoenix Enterprise TCP. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}